var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "176px",
    height: "115px",
    viewBox: "0 0 176 115",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "undraw_Notify_re_65on") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-10",
    transform: "translate(-100.000000, -101.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "undraw_Notify_re_65on",
    transform: "translate(100.000000, 101.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.950019,114.487342 L156,98.9237075 C156,98.9237075 161.444691,104.596434 161.444691,109.250978 L160.467439,98.4873418 C160.467439,98.4873418 163.259588,102.414615 162.980373,108.378251 C162.701157,114.341888 160.950019,114.487342 160.950019,114.487342 Z",
    id: "Path",
    fill: "#5E9A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9500195,100.487342 L48,85.8964335 C48,85.8964335 53.4446903,91.2146147 53.4446903,95.5782523 L52.4674399,85.4873418 C52.4674399,85.4873418 55.2595893,89.1691606 54.9803724,94.7600688 C54.7011554,100.350977 52.9500195,100.487342 52.9500195,100.487342 Z",
    id: "Path",
    fill: "#5E9A32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,107.279744 C129.008439,116.995637 109.609991,114.007043 85.8617483,114.027404 C62.1135056,114.047765 43.0084443,117.069364 43,107.353486 C42.9915612,97.6376084 62.3829122,95.5078512 86.1311548,95.4873418 C109.879397,95.4671249 128.991556,97.5638504 129,107.279744 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#3F3D56",
    x: 0,
    y: 114.26512,
    width: 176,
    height: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "113 94.4873418 109.612226 94.4873418 108 82.4873418 113 82.4873418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.510193,93.4873418 L113,93.4873418 L113,97.4873418 L103,97.4873418 L103,97.1214218 C103,95.1143724 104.571571,93.4873418 106.510193,93.4873418 L106.510193,93.4873418 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#A0616A",
    points: "136 112.487342 132.612226 112.487342 131 100.487342 136 100.487342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.510193,110.487342 L136,110.487342 L136,114.487342 L126,114.487342 L126,114.121422 C126,112.114372 127.571571,110.487342 129.510193,110.487342 L129.510193,110.487342 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.472516,76.6494174 C149.907183,76.1335268 150.086043,75.4557012 149.960966,74.7983335 C149.83589,74.1409658 149.419725,73.571584 148.824456,73.2434006 L141.611741,44.4873418 L137,46.4292816 L145.578996,74.2339512 C145.0708,75.2719883 145.436203,76.5179786 146.429541,77.1342267 C147.422879,77.7504747 148.730174,77.5421953 149.472516,76.6494174 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.268202,17.3174541 C143.739954,16.7424953 142.994236,16.440679 142.231704,16.4932175 C141.469173,16.545756 140.768157,16.9472524 140.317285,17.5896725 L129,18.9424363 L130.721596,23.4873418 L141.013994,21.4817705 C142.125152,22.2149437 143.587391,21.9669528 144.417626,20.9045259 C145.24786,19.8420989 145.183666,18.3010519 144.268202,17.3174541 L144.268202,17.3174541 Z",
    id: "Path",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,73.8510575 L130.927117,110.487342 L137.059586,109.236488 C137.059586,109.236488 136.157742,82.5551428 139.22399,79.3386323 C142.290238,76.1221217 135.280172,70.4873418 135.280172,70.4873418 L126,73.8510575 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.487507,64.1273557 L125.286673,67.4184361 C125.286673,67.4184361 108.340255,60.3976203 108.340255,71.5871379 C108.340255,82.7766554 107.3705,90.3703078 107.019755,90.8948095 C106.669011,91.4193111 111.077568,92.7803243 113.182089,92.430647 C113.182089,92.430647 115.778384,74.3913929 115.603006,73.3423807 C115.603006,73.3423807 132.226682,81.4676962 135.383463,80.7683548 C138.540244,80.0690134 139.286052,77.5933398 139.812174,76.1946504 C140.338296,74.795961 139.592091,63.6885449 139.592091,63.6885449 L129.069906,60.4873418 L127.487507,64.1273557 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.572149,43.4873418 L126.940693,42.7203027 C126.940693,42.7203027 119.868382,26.6124922 122.646788,22.26594 C125.425195,17.9193878 137.549161,17.2801897 137.928039,17.5358672 C138.306916,17.7915446 137.02308,21.1111173 137.907112,22.6452021 C137.907112,22.6452021 128.515206,24.7063754 127.883743,24.9620551 C127.252281,25.2177348 132.750093,34.6663919 132.750093,34.6663919 L132.118639,40.419179 L127.572149,43.4873418 Z",
    id: "Path",
    fill: "#1A91D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.374799,35.3792712 C140.374799,35.3792712 133.749598,36.1437913 133.494773,36.1437913 C133.239948,36.1437913 133.112555,34.4873418 133.112555,34.4873418 L127.251786,42.5147487 C127.251786,42.5147487 124.364376,65.8032357 125.128824,65.4209767 C125.893272,65.0387178 139.992579,67.2340693 140.11999,66.2147173 C140.247401,65.1953653 139.992579,60.0985962 140.374808,59.8437554 C140.757038,59.5889146 147,43.7889438 147,43.7889438 C147,43.7889438 146.362961,40.4760447 144.197027,39.32927 C142.031093,38.1824954 140.374799,35.3792712 140.374799,35.3792712 Z",
    id: "Path",
    fill: "#1A91D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921673,42.4873418 L147.049954,44.615787 C147.049954,44.615787 150.212154,69.0736428 148.482926,69.8248599 C146.753698,70.5760771 143.349477,70.4837472 143.349477,70.4837472 L140,58.8888995 L144.921673,42.4873418 Z",
    id: "Path",
    fill: "#1A91D7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A0616A",
    cx: 134,
    cy: 28.4873418,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.489744,29.2770034 C132.41078,28.0621607 130.880455,28.0205351 129.664926,28.0090325 C128.449398,27.9975299 126.996161,28.0409875 126.308372,27.0371874 C125.85384,26.3738096 125.94066,25.4528636 126.31617,24.7416303 C126.69168,24.0303969 127.309345,23.4833769 127.916998,22.9571329 C129.485812,21.5985049 131.10267,20.2506587 132.986162,19.3810469 C134.869655,18.5114352 137.07685,18.1600569 139.030224,18.8581321 C141.429785,19.7156522 144.673557,24.1298724 144.953666,26.6659881 C145.233776,29.2021039 144.221756,31.7874788 142.515823,33.6826329 C140.80989,35.577787 136.905328,34.813142 134.448122,35.4873418 C135.941966,33.3698792 134.957309,29.5223907 132.564197,28.5335896 L132.489744,29.2770034 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FEC532",
    cx: 81,
    cy: 90.4873418,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8825541,75.4873418 C66.875585,75.4873418 63.2437942,73.1448022 61.6135558,69.5081441 L39.1569324,19.2631921 C37.1299599,14.7280488 37.8008961,9.45024676 40.8991629,5.55823996 C43.9974298,1.66623315 49.0121741,-0.198250468 53.9210289,0.716705778 C58.8298838,1.63166202 62.8234597,5.17519688 64.2912107,9.91825892 L80.5525209,62.466911 C81.4966107,65.5171102 80.9285206,68.8314187 79.021475,71.3992226 C77.1144294,73.9670264 74.0945096,75.4839113 70.8825631,75.4873418 L70.8825541,75.4873418 Z",
    id: "Path",
    fill: "#FEC532"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.d96a8817b777b33846d178a1974b7a18.svg";
export { ForwardRef as ReactComponent };